import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { FinalProduct } from 'src/app/models/final_product.model';

export interface FinalProductState extends EntityState<FinalProduct> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'finalProduct' })
export class FinalProductStore extends EntityStore<FinalProductState, FinalProduct> {
  constructor() {
    super();
  }
}